module.exports = __webpack_public_path__ + "static/gluten-free-89c908b0cc0508cc97bd43d258a72ca5.png";